<template>
<div class="forums" v-bind:class="{forum__last: this.isLastSection}">
  <!-- forum section name -->
  <div class="forum__section_title" v-bind:class="{collapsed: forum.hide}">
    <!-- Столица — центр города -->
    <img src="../assets/nav_m.gif" /><span v-html="nbsp"></span>
    <template v-if="this.isSubforum">
      <a :href="'index.php?act=SF&f=' + forum.id">{{htmlDecode(forum.name)}}</a>
    </template>
    <template v-else>
      <a :href="'index.php?act=SC&c=' + forum.id">{{htmlDecode(forum.name)}}</a>
    </template>
    <!-- section collapse button -->
    <!--
    <div class="forum__toggleSectionBtn">
      <img v-if="forum.hide" src="../assets/exp_plus.gif" @click="toggleDisplay(forum)" />
      <img v-else src="../assets/exp_minus.gif" @click="toggleDisplay(forum)" />
    </div>
  -->
  </div>

  <!-- forums in this section -->
  <table width="100%" class="forum__table" v-if="!forum.hide">
    <!-- table header: Форум, Модераторы, Тем, Ответов, Последнее изменение -->
    <tr>
      <th class="forum__th"></th>
      <th width="56%" class="forum__th"><span>Форум</span></th>
      <th width="10%" class="forum__th forum__th_center"><span>Модераторы</span></th>
      <th width="7%" class="forum__th forum__th_center"><span>Тем</span></th>
      <th width="7%" class="forum__th forum__th_center"><span>Ответов</span></th>
      <th width="35%" class="forum__th"><span>Последнее изменение</span></th>
    </tr>

    <tr v-for="forum in forum.children">
      <!-- new posts icon - clicking it marks the forum as read -->
      <td width="1%" class="forum__newposts_icon forum__box">
        <template v-if="forum.redirect_url">
          <img src="../assets/br_redirect.gif" />
        </template>
        <template v-else>
          <template v-if="forum.children">
            <img v-if="forum.new_posts == 1" src="../assets/bc_new.gif" title="Отметить форум прочитанным?" @click="markAsRead(forum.id)" />
            <img v-else src="../assets/bc_new.gif" @click="markAsRead(forum.id)" />
          </template>
          <template v-else>
            <img v-if="forum.new_posts == 1" src="../assets/bf_new.gif" title="Отметить все подфорумы прочитанными?" @click="markAsRead(forum.id)" />
            <img v-else src="../assets/bf_new.gif" @click="markAsRead(forum.id)" />
          </template>
        </template>
      </td>

      <!-- forum name and description -->
      <td class="forum__name_descr_box forum__box">
        <span class="forum__name"><a :href="forum.redirect_url ? forum.redirect_url : 'index.php?act=SF&f=' + forum.id">{{ htmlDecode(forum.name) }}</a></span>
        <span class="forum__description">
          <span v-html="forum.description" />
          <template v-if="forum.children"> <br>
            <font color="white">Подфорумы: </font>
          </template>
          <!-- subforums -->
          <span class="forum__subforumlink" v-for="(subforum, index) in forum.children"><a :href="subforum.redirect_url ? subforum.redirect_url : 'index.php?act=SF&f=' + subforum.id">{{htmlDecode(subforum.name)}}</a>
            <template v-if="index != forum.children.length -1">, </template>
          </span>
        </span>

      </td>

      <!-- moderators -->
      <td width="10%" class="forum__topics_posts forum__box forum__table_lighter forum__11txt">
        <template v-if="forum.redirect_url">--</template>
        <template v-else>
          <span v-for="(moder, index) in forum.moders">
            <a :href="moder.isGroup ?
            'index.php?act=Members&max_results=30&filter=' + moder.id + '&sort_order=asc&sort_key=name&st=0&b=1'
            :
            'index.php?act=Profile&MID=' + moder.id">{{moder.name}}</a><template v-if="index != forum.moders.length -1">, </template>
          </span>
        </template>
      </td>

      <!-- number of threads -->
      <td width="7%" class="forum__topics_posts forum__box forum__table_lighter forum__11txt">
        <template v-if="forum.redirect_url">--</template>
        <template v-else>{{forum.topics | formatInt}}</template>
      </td>

      <!-- number of posts -->
      <td width="7%" class="forum__topics_posts forum__box forum__table_lighter forum__11txt">
        <template v-if="forum.redirect_url">--</template>
        <template v-else>{{forum.posts | formatInt}}</template>
      </td>

      <!-- last post: when, in what thread, by whom -->
      <td width="35%" class="forum__lastpost forum__box forum__table_lighter">
        <template v-if="forum.redirect_url"><span class="forum__redirecthits"><b>Переходов:</b> {{forum.redirect_hits}}</span></template>
        <template v-else>
          <span>{{ forum.last_post_time | formatDate }}</span><br>
          <span class="forum__overflow_ellipsis">Тема: <a :href="'index.php?act=ST&t=' + forum.last_thread_id + '&view=getlastpost'"
              :title="'К первому непрочитанному сообщению: ' + htmlDecode(forum.last_title)">{{ htmlDecode(forum.last_title) | formatTitle }}</a></span><br>
          <span class="forum__overflow_ellipsis">Автор:
            <!-- if registered user -->
            <template v-if="forum.last_poster_id > 0">
              <a :href="'index.php?act=Profile&MID=' + forum.last_poster_id">{{ htmlDecode(forum.last_poster_name) }}</a>
            </template>
            <!-- else-if unregistered user -->
            <template v-else>
              {{ htmlDecode(forum.last_poster_name) }}
            </template>
          </span>
        </template>
      </td>
    </tr>

    <!-- empty row, decorative -->
    <tr>
      <td colspan="6" class="forum__section_end">
      </td>
    </tr>
  </table>
</div>
</template>

<script>
export default {
  props: ['forum', 'isSubforum', 'isLastSection'],
  methods: {
    toggleDisplay(forumSection) {
      forumSection.hide = !forumSection.hide;
    },
    markAsRead(forumId) {
      console.log('marking as read: ' + forumId);
    }
  },
  filters: {
    formatTitle: function(value) {
      if (value.length < 28) return value;
      return value.substring(0, 27) + '...';
    }
  }
}
</script>

<style lang="scss">
@import "../skin-blue.scss";
@import "./ForumSection.scss";
</style>
